import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class SendAiMessageArgs extends ActionArgs {
  @Field(() => String)
  prompt: string

  @Field(() => String)
  topic: string
}
